import React, { PropTypes } from 'react';
import Button from '../../../common/components/Button';
import {isEmpty} from 'lodash';

export default function SubmissionBar(props) {

  const {
    onNext,
    onSave,
    onBack,
    errors,
    showError,
    hideBack,
    finalStep,
    submitDisabled
  } = props;

  return (
    <ul className='submission-bar'>
      {
        onBack
        &&
        <li className='submission-bar-item button'
          data-id='Back'
          onClick={onBack} >
          Back
        </li>
      }
      {
        !isEmpty(errors) && showError
        &&
        <li className='submission-bar-item'>
          <div className='error-message'>{errors.join(' ')}</div>
        </li>
      }
      {
        !hideBack
        &&
        <li
          className='submission-bar-item right button'
          data-id='Save'
          onClick={onSave} >
          Save
        </li>
      }
      <li className='submission-bar-item'>
        <Button
          data-id='Next'
          className='button-main-large'
          disabled={submitDisabled}
          onClick={onNext}
          label={finalStep ? 'Submit' : 'Next'}
        />
      </li>
    </ul>
  );
}

SubmissionBar.propTypes = {
  onNext : PropTypes.func.isRequired,
  onSave : PropTypes.func.isRequired,
  onBack : PropTypes.func,
  errors: PropTypes.array,
  showError: PropTypes.bool,
  submitDisabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ./shared/react/client/SubmissionBar/index.js